import React from 'react';
import { Typography } from '@mui/material';
import Modal, { ModalAction } from '@/components/topstep/modal';
import { useTradingAccount } from '@/contexts/TradingAccountContext';
import SymbolBlocks from './symbolBlocks';

interface SymbolBlocksModalProps {
  onClose: () => void;
}

const SymbolBlocksModal = ({ onClose }: SymbolBlocksModalProps) => {
  const { activeTradingAccount } = useTradingAccount();

  const actions: ModalAction[] = [{ label: 'Close', onClick: onClose }];

  const header = (
    <Typography variant="h5" style={{ color: '#fff', marginBottom: '1em' }}>
      Symbol Blocks for {activeTradingAccount.accountName}
    </Typography>
  );

  return (
    <Modal actions={actions} header={header}>
      <SymbolBlocks onClose={onClose} />
    </Modal>
  );
};

export default SymbolBlocksModal;